import { CompressionSubSamplingEnum } from './shared/enums/compression-sub-sampling.enum';

export enum WallColor {
    black,
    white
}

export class SpaceWallConstants {

    public static MAX_WALLS_QUANTITY = 16;
    public static DEFAULT_CELL_WIDTH = 71;
    public static DEFAULT_MONITOR_CONTRAST = 0;
    public static DEFAULT_MONITOR_BRIGHTNESS = 0;
    public static DEFAULT_MONITOR_COMPRESSION_QUALITY = 70;
    public static DEFAULT_MONITOR_COMPRESSION_SUB_SAMPLING = CompressionSubSamplingEnum.YUV420;

    public static DEFAULT_RETICULUM_MONITOR_HEIGHT = 40;
    public static RETICULUM_SINGLE_MONITOR_LEFT_MARGIN = 35.55;
    public static RETICULUM_SINGLE_MONITOR_TOP_MARGIN = 20;

    public static CANVAS_CONTAINER_ID_NAME = 'drawer-container';
    public static LOCAL_STORAGE_APPROVED_WALL_KEY = 'isWallApproved';
    public static LOCAL_STORAGE_LOCKED_WALL_KEY = 'isWallLocked';

    // Validators

    public static MIN_VALIDATION_VALUE = 0;
    public static PERCENTAGE_REGEXP: RegExp = RegExp(/^(\d\d?(\.\d\d?)?|100(\.00?)?)$/g);
    public static NUMBER_REGEX: RegExp = RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);
}
